import { HolidaysTemplate } from "../../Templates/HolidaysTemplate";

export const Holidays = () => {
  return <HolidaysTemplate />;
};
